// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PartnerNavController from "./partner_nav_controller"
application.register("partner-nav", PartnerNavController)

import SyncNowController from "./sync_now_controller"
application.register("sync-now", SyncNowController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
